import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  styled,
  Typography,
} from "@mui/material";
import { useCallback, useState } from "react";
import { postSubscribedRecruit } from "../../api/recruiment";
import { fDate, validate } from "./ultil";
import { enqueueSnackbar } from "notistack";
import ApplySuccess from "./components/apply-success";
import RecruitmentApplyForm from "./recruitment-form";

// ------------------------------------------------------------

const defaultValues = {
  fullname: "",
  email: "",
  phoneNumber: "",
  dateOfBirth: "",
  address: "",
  fileCV: "",
  coverLetter: "",
};

const showNotification = (message, variant) => {
  enqueueSnackbar(message, {
    variant,
    anchorOrigin: { vertical: "top", horizontal: "right" },
    autoHideDuration: 3000,
  });
};

function RecruitmentApplyModal({ openModal, onClose, recruitment }) {
  const [selectedFile, setSelectedFile] = useState(null);
  const [registerSuceess, setRegisterSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState(defaultValues);

  const [errors, setErrors] = useState({
    fullname: null,
    email: null,
    phoneNumber: null,
    dateOfBirth: null,
    address: null,
    fileCV: null,
    coverLetter: null,
  });

  const handleUpdateFormData = useCallback((key, value) => {
    setFormData((prev) => ({ ...prev, [key]: value }));
  }, []);

  const onSave = async (data) => {
    const submitData = new FormData();
    submitData.append("uploadedFile", selectedFile || "");
    submitData.append("dataJson", JSON.stringify(data));

    setLoading(true);
    try {
      const { code } = await postSubscribedRecruit(submitData);
      if (code === 1) {
        setRegisterSuccess(true);
        setLoading(false);
      }
      showNotification(
        code === 1
          ? "Nộp đơn thành công"
          : "Nộp đơn thất bại, vui lòng thử lại sau!",
        code === 1 ? "success" : "error"
      );
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const validateForm = (submitData) => {
    const errors = validate(submitData);

    const newErrors = {};
    if (errors) {
      if (errors.fullname) newErrors.fullname = errors.fullname;
      if (errors.email) newErrors.email = errors.email;
      if (errors.phoneNumber) newErrors.phoneNumber = errors.phoneNumber;
      if (errors.dateOfBirth) newErrors.dateOfBirth = errors.dateOfBirth;
      if (errors.address) newErrors.address = errors.address;
      if (errors.fileCV) newErrors.fileCV = errors.fileCV;
      if (errors.coverLetter) newErrors.coverLetter = errors.coverLetter;
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    const inValid = validateForm(formData);

    if (!inValid) {
      showNotification("Vui lòng kiểm tra lại thông tin!", "error");
      return;
    }

    const params = {
      recruitsID: recruitment.id,
      fullname: formData.fullname,
      email: formData.email,
      phoneNumber: formData.phoneNumber,
      dateOfBirth: fDate(formData.dateOfBirth),
      address: formData.address,
      coverLetter: formData.coverLetter,
      fileCV: formData.fileCV,
    };

    onSave(params);
  };

  const handleDrop = useCallback(
    (acceptedFiles) => {
      const file = acceptedFiles[0];
      const newFile = Object.assign(file, {
        preview: URL.createObjectURL(file),
      });

      if (newFile) {
        setSelectedFile(newFile);
        handleUpdateFormData("fileCV", newFile.preview);
        setErrors((prev) => ({ ...prev, fileCV: null }));
      }
    },
    [handleUpdateFormData]
  );

  const header = () => (
    <Stack
      flexDirection="row"
      justifyContent="space-between"
      alignItems="center"
    >
      <Box>
        <Typography color="#033F6A" variant="h5" fontWeight={600} mb={0.8}>
          Ứng tuyển công việc
        </Typography>
        <Typography color="#1C9BDB" fontWeight={600}>
          Vị trí: {recruitment?.title}
        </Typography>
      </Box>
      <IconButton
        onClick={onClose}
        sx={{ width: 36, height: 36, bgcolor: "#E2E2E2" }}
      >
        <img src="/assets/icons/ic_close.svg" className="w-6 h-6" />
      </IconButton>
    </Stack>
  );

  return (
    <Dialog open={openModal} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ boxShadow: " 0px 2px 4.8px 0px rgba(0, 0, 0, 0.10)" }}>
        {header()}
      </DialogTitle>

      <DialogContent>
        {!registerSuceess ? (
          <RecruitmentApplyForm
            formData={formData}
            selectedFile={selectedFile}
            handleUpdateFormData={handleUpdateFormData}
            handleDrop={handleDrop}
            errors={errors}
            setErrors={setErrors}
          />
        ) : (
          <ApplySuccess />
        )}
      </DialogContent>

      {!registerSuceess && (
        <DialogActionsStyled>
          <CancleButton
            fullWidth
            size="large"
            variant="outlined"
            onClick={onClose}
          >
            Hủy
          </CancleButton>
          <ConfirmButton
            loading={loading}
            fullWidth
            size="large"
            variant="contained"
            onClick={handleSubmit}
          >
            Nộp hồ sơ ứng tuyển ngay
          </ConfirmButton>
        </DialogActionsStyled>
      )}
    </Dialog>
  );
}

export default RecruitmentApplyModal;

const CancleButton = styled(Button)({
  borderRadius: "30px",
  width: 120,
  height: 48,
  borderColor: "#E2E2E2",
  textTransform: "none",
  color: "#606060",
});

const ConfirmButton = styled(Button)({
  backgroundColor: "#27C6FF",
  borderRadius: "30px",
  flex: 1,
  height: 48,
  textTransform: "none",
});

const DialogActionsStyled = styled(DialogActions)(({ theme }) => ({
  boxShadow: "0px -4px 10px 0px rgba(0, 0, 0, 0.05)",
  padding: theme.spacing(2, 3),
  flexDirection: "column-reverse",
  gap: theme.spacing(1),
  flex: 1,
  [theme.breakpoints.up("sm")]: {
    flexDirection: "row",
  },
}));
